// extracted by mini-css-extract-plugin
export var color_block = "Legend-module--color_block--k1DjS";
export var legend = "Legend-module--legend--BxiFv";